<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" 
    closable mask-closable :okText="getTranslation('c006')" :cancelText="getTranslation('b182')"
    :title="getTranslation('u047')" width="80">
    <div class="auth-container">
      <!-- 全选按钮 -->
      <div class="select-all-section">
        <Checkbox v-model="selectAll" @on-change="handleSelectAll">{{ getTranslation('b056') }}</Checkbox>
      </div>
      <!-- 权限分组 -->
      <div class="auth-groups">
        <div v-for="(group, groupIndex) in authList" :key="groupIndex" class="auth-group">
          <div class="group-header">
            <Checkbox v-model="group.selectedAll" @on-change="(checked) => handleGroupSelectAll(checked, group)">
              {{ group.name }}
            </Checkbox>
          </div>
          <div class="group-items">
            <CheckboxGroup v-model="selectedAuths">
              <div class="checkbox-grid">
                <div v-for="(item, key) in group.list" :key="key" class="auth-item">
                  <Checkbox :label="key">{{ item.name }}</Checkbox>
                </div>
              </div>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </div>
     <div slot="footer">
        <Row type="flex" class="menu-actions flex-right">
          <Col flex="1" >
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>
</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'UserRole', // 组件名称
  components: {
   
  },
  props: {
    propVisible: Boolean,
    authId: Number
  },
  data() {
    return {
      user: {},
      title: '',
      modalLoading: true,
      selectAll: false,
      selectedAuths: [], // 选中的权限key数组
      authList: [] // 权限列表数据
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.authId > 0) {
          this.title = this.getTranslation('u042');
          this.getOneUser(this.authId)
        }
      }
    },
    // 监听权限选择变化，更新全选状态
    selectedAuths: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true
    }
  },

  created() {
    this.initAuthData();
  },
  methods: {
    // 初始化权限数据
    initAuthData() {
      this.authList = [
        {
          name: this.getTranslation("u045"),
          selectedAll: false,
          list: {
            "productline.view": { name: this.getTranslation("u046"), key: "productline.view" },
            "productline.manage": { name: this.getTranslation("p004"), key: "productline.manage" }
          }
        },
        {
          name: this.getTranslation("u048"),
          selectedAll: false,
          list: {
            "machine.view": { name: this.getTranslation("u049"), key: "machine.view" },
            "machine.manage": { name: this.getTranslation("m007"), key: "machine.manage" },
            "machine.connect": { name: this.getTranslation("u050"), key: "machine.connect" },
            "machine.softwareUpgrade": { name: this.getTranslation("m104"), key: "machine.softwareUpgrade" }

          }
        },
        {
          name: this.getTranslation("u051"),
          selectedAll: false,
          list: {
            "user.view": { name: this.getTranslation("u052"), key: "user.view" },
            "user.manage": { name: this.getTranslation("u001"), key: "user.manage" }
          }
        },
        {
          name: this.getTranslation("u004"),
          selectedAll: false,
          list: {
            "role.view": { name: this.getTranslation("u077"), key: "role.view" },
            "role.manage": { name: this.getTranslation("u029"), key: "role.manage" }
          }
        },
        {
          name: this.getTranslation("p089"),
          selectedAll: false,
          list: {
            "library.view": { name: this.getTranslation("p056"), key: "library.view" },
            "library.system": { name: this.getTranslation("k004"), key: "library.system" },
            "library.program": { name: this.getTranslation("m092"), key: "library.program" }
          }
        },
        {
          name: this.getTranslation("s001"),
          selectedAll: false,
          list: {
            "history.view": { name: this.getTranslation("u055"), key: "history.view" },
            "history.manage": { name: this.getTranslation("u056"), key: "history.manage" },
          }
        },
        {
          name: this.getTranslation("i001"),
          selectedAll: false,
          list: {
            "init.view": { name: this.getTranslation("u057"), key: "init.view" },
            "init.manage": { name: this.getTranslation("u058"), key: "init.manage" }
          }
        },
        {
          name: this.getTranslation("u085"),
          selectedAll: false,
          list: {
            "register.view": { name: this.getTranslation("u094"), key: "register.view" },
            "register.manage": { name: this.getTranslation("u095"), key: "register.manage" }
          }
        },
        {
          name: this.getTranslation("k001"),
          selectedAll: false,
          list: {
            "running.view": { name: this.getTranslation("u061"), key: "running.view" },
            "running.manage": { name: this.getTranslation("u062"), key: "running.manage" }
          }
        },
        {
          name: this.getTranslation("k002"),
          selectedAll: false,
          list: {
            "program.view": { name: this.getTranslation("u063"), key: "program.view" },
            "program.manage": { name: this.getTranslation("u064"), key: "program.manage" }
          }
        },
        {
          name: this.getTranslation("k003"),
          selectedAll: false,
          list: {
            "production.view": { name: this.getTranslation("u065"), key: "production.view" },
            "production.manage": { name: this.getTranslation("u066"), key: "production.manage" }
          }
        },
        {
          name: this.getTranslation("k004"),
          selectedAll: false,
          list: {
            "system.view": { name: this.getTranslation("u067"), key: "system.view" },
            "system.manage": { name: this.getTranslation("u068"), key: "system.manage" }
          }
        },
        {
          name: this.getTranslation("k005"),
          selectedAll: false,
          list: {
            "record.view": { name: this.getTranslation("u069"), key: "record.view" },
            "record.manage": { name: this.getTranslation("u070"), key: "record.manage" }
          }
        },
        {
          name: this.getTranslation("k006"),
          selectedAll: false,
          list: {
            "alarm.view": { name: this.getTranslation("u071"), key: "alarm.view" },
            "alarm.manage": { name: this.getTranslation("u072"), key: "alarm.manage" }
          }
        },
        {
          name: this.getTranslation("k007"),
          selectedAll: false,
          list: {
            "modification.view": { name: this.getTranslation("u073"), key: "modification.view" },
            "modification.manage": { name: this.getTranslation("u074"), key: "modification.manage" }
          }
        },
        {
          name: this.getTranslation("k008"),
          selectedAll: false,
          list: {
            "prodspot.view": { name: this.getTranslation("u075"), key: "prodspot.view" },
            "prodspot.manage": { name: this.getTranslation("u076"), key: "prodspot.manage" }
          }
        },
        {
          name: this.getTranslation("s336"),
          selectedAll: false,
          list: {
            "setting.view": { name: this.getTranslation("s340"), key: "setting.view" },
            "setting.manage": { name: this.getTranslation("s341"), key: "setting.manage" }
          }
        }
        ,
        {
          name: this.getTranslation("e001"),
          selectedAll: false,
          list: {
            "expulsion.view": { name: this.getTranslation("e002"), key: "expulsion.view" },
            "expulsion.manage": { name: this.getTranslation("e003"), key: "expulsion.manage" }
          }
        } ,
        {
          name: this.getTranslation("p050"),
          selectedAll: false,
          list: {
            "fixAlarm.view": { name: this.getTranslation("p051"), key: "fixAlarm.view" },
            "fixAlarm.manage": { name: this.getTranslation("p052"), key: "fixAlarm.manage" }
          }
        }
        ,
        {
          name: this.getTranslation("p047"),
          selectedAll: false,
          list: {
            "fix.view": { name: this.getTranslation("p048"), key: "fix.view" },
            "fix.manage": { name: this.getTranslation("p049"), key: "fix.manage" }
          }
        }
      ];
    },

    // 全选/全不选
    handleSelectAll(checked) {
      this.selectAll = checked;
      if (checked) {
        // 获取所有权限key
        const allKeys = [];
        this.authList.forEach(group => {
          Object.keys(group.list).forEach(key => {
            allKeys.push(key);
          });
        });
        this.selectedAuths = allKeys;
        // 设置所有分组为全选状态
        this.authList.forEach(group => {
          group.selectedAll = true;
        });
      } else {
        this.selectedAuths = [];
        // 设置所有分组为非全选状态
        this.authList.forEach(group => {
          group.selectedAll = false;
        });
      }
    },

    // 分组全选/全不选
    handleGroupSelectAll(checked, group) {
      group.selectedAll = checked;
      const groupKeys = Object.keys(group.list);

      if (checked) {
        // 添加该分组的所有权限
        groupKeys.forEach(key => {
          if (!this.selectedAuths.includes(key)) {
            this.selectedAuths.push(key);
          }
        });
      } else {
        // 移除该分组的所有权限
        this.selectedAuths = this.selectedAuths.filter(key => !groupKeys.includes(key));
      }

      // 更新全选状态
      this.updateSelectAllStatus();
    },

    // 更新全选状态
    updateSelectAllStatus() {
      const totalKeys = this.getAllAuthKeys();
      this.selectAll = this.selectedAuths.length === totalKeys.length;

      // 更新分组全选状态
      this.authList.forEach(group => {
        const groupKeys = Object.keys(group.list);
        const selectedGroupKeys = this.selectedAuths.filter(key => groupKeys.includes(key));
        group.selectedAll = selectedGroupKeys.length === groupKeys.length;
      });
    },

    // 获取所有权限key
    getAllAuthKeys() {
      const allKeys = [];
      this.authList.forEach(group => {
        Object.keys(group.list).forEach(key => {
          allKeys.push(key);
        });
      });
      return allKeys;
    },

    getOneUser(id) {
      let url = API_URL["roleGetOne"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data;
            if (res.data.data.auth) {
              if (res.data.data.auth == "all") {
                const allKeys = [];
                this.authList.forEach(group => {
                  Object.keys(group.list).forEach(key => {
                    allKeys.push(key);
                  });
                });
                this.selectedAuths = allKeys;
              } else {
                this.selectedAuths = res.data.data.auth.split(",")
              }
            } else {
              this.selectedAuths = [];
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      let _this = this;
      this.modalLoading = true;

      let url = API_URL["roleUpdateAuth"];
      let params = {};
      params.auth = this.selectedAuths.join(",");
      params.id = this.authId;
      params.name = this.user.name;

      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('u078'));
            this.visible = false
            _this.$emit("refresh-page")

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css'); 
.auth-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 8px;
}

.select-all-section {
  padding: 8px 0;
  margin-bottom: 12px;
  border-bottom: 1px solid #e8eaec;
}

.select-all-section .ivu-checkbox-wrapper {
  font-size: 14px;
}

.auth-groups {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.auth-group {
  border: 1px solid #e8eaec;
  border-radius: 4px;
  overflow: hidden;
}

.group-header {
  background-color: #f8f8f9;
  padding: 2px 5px;
  border-bottom: 1px solid #e8eaec;
}

.group-header .ivu-checkbox-wrapper {
  color: #515a6e;
  font-size: 13px;
}

.group-items {
  padding: 10px 15px;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px 12px;
}

.auth-item {
  display: flex;
  align-items: center;
}

.auth-item .ivu-checkbox-wrapper {
  padding: 2px 0;
  font-size: 13px;
}

/* 滚动条样式 */
.auth-container::-webkit-scrollbar {
  width: 6px;
}

.auth-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.auth-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.auth-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
}

.field-line {
  margin-bottom: 8px;
}
</style>
